import { defineComponent as _defineComponent } from 'vue'
import {
  computed,
  ref,
  useContext,
  onBeforeUnmount,
  onMounted,
  onUpdated,
  useStore,
} from '@nuxtjs/composition-api';
import MenuItem from './MenuItem.vue';
import { useRibbonMenu } from '~/composables/useRibbonMenu';
import { RibbonMenuItem, ribbonMenuLinks } from '~/data/ribbon_menu_links';
import { useUser } from '~/composables/useUser';
import { navigationLinks, ResourceNavigationInfo } from '~/data/navigation_links_main';
import DropdownMenu from '~/components/DropdownMenu.vue';
import { useTwoRowHeader } from '~/composables/useTwoRowHeader';
import TNavigationIconItem from '~/components/header/NavigationDropdownItemWithIcon.vue';
import { truncateString } from '~/utils/formatStrings';
import { State } from '~/store';
import { useLocale } from '~/composables/useLocale';


export default /*#__PURE__*/_defineComponent({
  __name: 'Menu',
  setup(__props) {

const store = useStore<State>();

const { openNavEvent, linkClickedEvent } = useTwoRowHeader();
const { user } = useUser();

const showLinkForUser = (link: RibbonMenuItem): boolean => {
  if (link?.hideForPlus) {
    return !user.value || user.value?.subscription?.code === 'free';
  } else {
    return true;
  }
};

const scrollable = ref<HTMLElement | null>(null);
const controls = ref<HTMLElement | null>(null);
const ribbonItems = ref<HTMLElement | null>(null);

const { megaMenuOpen, toggleMegaMenu, scroll, shouldMenuBeVisible, hasReachedEndOfScroll } =
  useRibbonMenu(scrollable, ribbonItems);

const firstTrendingTopic = computed(() => store.getters.trendingTopics?.[0]);

const trendingTopicTitle = computed(() => truncateString(firstTrendingTopic.value.name, 20));

const { i18n, localePath } = useContext();

const secondRowDropdowns = computed(() => [
  {
    label: i18n.tc('learning_areas_label'),
    link: localePath('/learning-areas/'),
    items: navigationLinks[locale.value].learning_areas,
  },
  {
    label: i18n.tc('grade_levels_label'),
    link: localePath('/year-levels/'),
    items: navigationLinks[locale.value].year_levels,
  },
]);
const isResourceDropdown = (item: any): item is ResourceNavigationInfo<'us' | 'au' | 'gb'> => {
  return item.icon !== undefined && item.description !== undefined && item.type !== undefined;
};

const locale = useLocale();

onMounted(() => {
  window.addEventListener('resize', shouldMenuBeVisible);
  shouldMenuBeVisible();
});

onUpdated(() => {
  shouldMenuBeVisible();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', shouldMenuBeVisible);
});

return { __sfc: true,store, openNavEvent, linkClickedEvent, user, showLinkForUser, scrollable, controls, ribbonItems, megaMenuOpen, toggleMegaMenu, scroll, shouldMenuBeVisible, hasReachedEndOfScroll, firstTrendingTopic, trendingTopicTitle, i18n, localePath, secondRowDropdowns, isResourceDropdown, locale, MenuItem, ribbonMenuLinks, DropdownMenu, TNavigationIconItem }
}

})